@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.onboarding_language.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mifos_mobile.feature.onboarding_language.generated.resources/"

internal val Res.string.feature_onboarding_arabic: StringResource by lazy {
      StringResource("string:feature_onboarding_arabic", "feature_onboarding_arabic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 57),
      ))
    }

internal val Res.string.feature_onboarding_bengali: StringResource by lazy {
      StringResource("string:feature_onboarding_bengali", "feature_onboarding_bengali", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68, 70),
      ))
    }

internal val Res.string.feature_onboarding_burmese: StringResource by lazy {
      StringResource("string:feature_onboarding_burmese", "feature_onboarding_burmese", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139, 70),
      ))
    }

internal val Res.string.feature_onboarding_choose_your_app_language: StringResource by lazy {
      StringResource("string:feature_onboarding_choose_your_app_language", "feature_onboarding_choose_your_app_language", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210, 83),
      ))
    }

internal val Res.string.feature_onboarding_chosen_language_can_be_changed_later_in_the_settings:
    StringResource by lazy {
      StringResource("string:feature_onboarding_chosen_language_can_be_changed_later_in_the_settings", "feature_onboarding_chosen_language_can_be_changed_later_in_the_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294, 147),
      ))
    }

internal val Res.string.feature_onboarding_default: StringResource by lazy {
      StringResource("string:feature_onboarding_default", "feature_onboarding_default", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 442, 54),
      ))
    }

internal val Res.string.feature_onboarding_english: StringResource by lazy {
      StringResource("string:feature_onboarding_english", "feature_onboarding_english", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 497, 46),
      ))
    }

internal val Res.string.feature_onboarding_farsi: StringResource by lazy {
      StringResource("string:feature_onboarding_farsi", "feature_onboarding_farsi", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 544, 56),
      ))
    }

internal val Res.string.feature_onboarding_french: StringResource by lazy {
      StringResource("string:feature_onboarding_french", "feature_onboarding_french", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 601, 57),
      ))
    }

internal val Res.string.feature_onboarding_hindi: StringResource by lazy {
      StringResource("string:feature_onboarding_hindi", "feature_onboarding_hindi", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 659, 68),
      ))
    }

internal val Res.string.feature_onboarding_indonesian: StringResource by lazy {
      StringResource("string:feature_onboarding_indonesian", "feature_onboarding_indonesian", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 728, 77),
      ))
    }

internal val Res.string.feature_onboarding_kannada: StringResource by lazy {
      StringResource("string:feature_onboarding_kannada", "feature_onboarding_kannada", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 806, 66),
      ))
    }

internal val Res.string.feature_onboarding_khmer: StringResource by lazy {
      StringResource("string:feature_onboarding_khmer", "feature_onboarding_khmer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 873, 80),
      ))
    }

internal val Res.string.feature_onboarding_polish: StringResource by lazy {
      StringResource("string:feature_onboarding_polish", "feature_onboarding_polish", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 954, 53),
      ))
    }

internal val Res.string.feature_onboarding_portuguese: StringResource by lazy {
      StringResource("string:feature_onboarding_portuguese", "feature_onboarding_portuguese", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1008, 69),
      ))
    }

internal val Res.string.feature_onboarding_russian: StringResource by lazy {
      StringResource("string:feature_onboarding_russian", "feature_onboarding_russian", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1078, 66),
      ))
    }

internal val Res.string.feature_onboarding_spanish: StringResource by lazy {
      StringResource("string:feature_onboarding_spanish", "feature_onboarding_spanish", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1145, 58),
      ))
    }

internal val Res.string.feature_onboarding_submit: StringResource by lazy {
      StringResource("string:feature_onboarding_submit", "feature_onboarding_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1204, 41),
      ))
    }

internal val Res.string.feature_onboarding_swahili: StringResource by lazy {
      StringResource("string:feature_onboarding_swahili", "feature_onboarding_swahili", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1246, 58),
      ))
    }

internal val Res.string.feature_onboarding_telugu: StringResource by lazy {
      StringResource("string:feature_onboarding_telugu", "feature_onboarding_telugu", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1305, 69),
      ))
    }

internal val Res.string.feature_onboarding_urdu: StringResource by lazy {
      StringResource("string:feature_onboarding_urdu", "feature_onboarding_urdu", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1375, 55),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_onboarding_arabic", Res.string.feature_onboarding_arabic)
  map.put("feature_onboarding_bengali", Res.string.feature_onboarding_bengali)
  map.put("feature_onboarding_burmese", Res.string.feature_onboarding_burmese)
  map.put("feature_onboarding_choose_your_app_language", Res.string.feature_onboarding_choose_your_app_language)
  map.put("feature_onboarding_chosen_language_can_be_changed_later_in_the_settings", Res.string.feature_onboarding_chosen_language_can_be_changed_later_in_the_settings)
  map.put("feature_onboarding_default", Res.string.feature_onboarding_default)
  map.put("feature_onboarding_english", Res.string.feature_onboarding_english)
  map.put("feature_onboarding_farsi", Res.string.feature_onboarding_farsi)
  map.put("feature_onboarding_french", Res.string.feature_onboarding_french)
  map.put("feature_onboarding_hindi", Res.string.feature_onboarding_hindi)
  map.put("feature_onboarding_indonesian", Res.string.feature_onboarding_indonesian)
  map.put("feature_onboarding_kannada", Res.string.feature_onboarding_kannada)
  map.put("feature_onboarding_khmer", Res.string.feature_onboarding_khmer)
  map.put("feature_onboarding_polish", Res.string.feature_onboarding_polish)
  map.put("feature_onboarding_portuguese", Res.string.feature_onboarding_portuguese)
  map.put("feature_onboarding_russian", Res.string.feature_onboarding_russian)
  map.put("feature_onboarding_spanish", Res.string.feature_onboarding_spanish)
  map.put("feature_onboarding_submit", Res.string.feature_onboarding_submit)
  map.put("feature_onboarding_swahili", Res.string.feature_onboarding_swahili)
  map.put("feature_onboarding_telugu", Res.string.feature_onboarding_telugu)
  map.put("feature_onboarding_urdu", Res.string.feature_onboarding_urdu)
}
